export class EcmListResource {
  id: string;
  description: string;
  value: string;
}